/**
 * @generated SignedSource<<bb182e7afa6b53c7cb4a37e1327cd70b>>
 * @relayHash 0052e35cbfb1580b9efb5483189d22df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 872ed8b624808067a74da03585209a3f18a899ed7f117c065aed543c45c4d484

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "872ed8b624808067a74da03585209a3f18a899ed7f117c065aed543c45c4d484",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
